<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="作者id">
              <a-input placeholder="请输入作者id" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="标题">
              <a-input placeholder="请输入标题" v-model="queryParam.title"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="发布类型">
              <a-select v-model="queryParam.publishSetting" style="width: 100%" @change="$event => queryParam.publishSetting = $event">
                    <a-select-option v-for="(item , index) in publishOptions" :key="index" :value="item.value">
                        {{ item.label }}
                    </a-select-option>
                </a-select>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="内容">
                <a-input placeholder="请输入内容" v-model="queryParam.content"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="图片链接">
                <a-input placeholder="请输入图片链接" v-model="queryParam.imageUrl"></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="视频链接">
                <a-input placeholder="请输入视频链接" v-model="queryParam.videoUrl"></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <!-- <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('文章审核')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div> -->

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <!--         :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" -->
        <span slot="content" slot-scope="text, record">
          <a @click="checkDetail(record)">详情</a>
        </span>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
          <a-popconfirm
            title="你确定通过该文章的审核吗？"
            ok-text="Yes"
            cancel-text="No"
            @confirm="passConfirm(record)"
            v-if="record.status == 0"
          >
            <a style="margin-right: 10px">通过</a>
          </a-popconfirm>
          <a v-if="record.status == 0" @click="noPass(record)">不通过</a>
        </span>
           <span slot="imageUrl" slot-scope="text, record" v-if="text">
            <a @click="goDetails(text)">详情</a>
          
        </span>
           <span slot="videoUrl" slot-scope="text, record" v-if="text">
           <a @click="goDetails(text)">详情</a>
        </span>
        <span slot="videoTag" slot-scope="text, record">
          {{ typeMenu[text] }}
        </span>
        <span slot="publishSetting" slot-scope="text, record">
          {{ publishSettingOptions[text] }}
        </span>
     
        <span slot="worksNarrate" slot-scope="text, record">
          {{ worksNarrateMenu[text] }}
        </span>
        <span slot="chargeStatus" slot-scope="text, record">
          {{ chargeStatusMenu[text] }}
        </span>
        <span slot="contentType" slot-scope="text, record">
          {{ contentTypeMenu[text] }}
        </span>
        <span slot="status" slot-scope="text, record">
          {{ statusMenu[text] }}
        </span>
        <span slot="creationType" slot-scope="text, record">
          {{ creationTypeMenu[text] }}
        </span>
        <span slot="source" slot-scope="text, record">
          {{ sourceMenu[text] }}
        </span>
      </a-table>

      <a-modal title="作品内容" :visible="showPreview" @ok="handleOk" @cancel="cancel" width="800px">
        <div class="box">
          <div class="myPhone">
            <div class="title font-size-36px">{{ selectRecord.title }}</div>
            <div class="html" v-html="selectRecord.content"></div>
          </div>
        </div>
      </a-modal>

      <a-modal title="不通过原因" :visible="visible" @ok="noPassConfirm" @cancel="handleCancel">
        <a-input placeholder="请输入不通过原因 " v-model="reason" />
      </a-modal>
      <!-- <div class="preview" v-show="showPreview">
        <div class="box">
          <div class="phone">
            <div class="title font-size-36px">{{ selectRecord.title }}</div>
            <div class="html" v-html="selectRecord.content"></div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <article-modal ref="modalForm" @ok="modalFormOk"></article-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import ArticleModal from './modules/ArticleModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { CloseOutlined } from '@ant-design/icons-vue'
import { httpAction } from '@/api/manage'
export default {
  name: 'ArticleList',
  mixins: [JeecgListMixin],
  components: {
    ArticleModal,
  },
  data() {
    return {
      selectRecord: {},
      showPreview: false,
      visible: false,
      reason: '',
      publishOptions:[
          { value: '', label: '全部' },
          { value: '2', label: '家长学校' },
          { value: '1', label: '普通发布' },
          { value: '3', label: '轻干预方案' }
      ],
      description: '文章审核管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '作者id',
          align: 'center',
          dataIndex: 'userId',
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title',
        },
        {
          title: '内容',
          align: 'center',
          dataIndex: 'content',
          width: 150,
          scopedSlots: { customRender: 'content' },
        },
        {
          title: '图片链接',
          align: 'center',
          dataIndex: 'imageUrl',
            scopedSlots: { customRender: 'imageUrl' },
        },
        {
          title: '视频链接',
          align: 'center',
          dataIndex: 'videoUrl',
            scopedSlots: { customRender: 'videoUrl' },
        },
        {
          title: '文章类别',
          align: 'center',
          dataIndex: 'videoTag',
          scopedSlots: { customRender: 'videoTag' },
        },
        // (1.取材网络  2.引用站内 3.个人观点，仅供参考 4.引用AI 5.虚构演绎，故事经历 )
        {
          title: '发布类别',
          align: 'center',
          dataIndex: 'publishSetting',
          scopedSlots: { customRender: 'publishSetting' },
        },
        {
          title: '作品声明 ',
          align: 'center',
          dataIndex: 'worksNarrate',
          scopedSlots: { customRender: 'worksNarrate' },
        },
        //  (0.不收费文章 1.收费文章)
        {
          title: '收费状态',
          align: 'center',
          dataIndex: 'chargeStatus',
          scopedSlots: { customRender: 'chargeStatus' },
        },
        //  (1.文章 2.视频 3.主题文章)
        {
          title: '文章类型',
          align: 'center',
          dataIndex: 'contentType',
          scopedSlots: { customRender: 'contentType' },
        },
        // (0.审核中 1.已发布 2未通过 3.草稿）
        {
          title: '审核状态 ',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        //  1 原创 2转载
        {
          title: '创作类型',
          align: 'center',
          dataIndex: 'creationType',
          scopedSlots: { customRender: 'creationType' },
        },
        {
          title: '展现量',
          align: 'center',
          dataIndex: 'showCount',
        },
        {
          title: '浏览量',
          align: 'center',
          dataIndex: 'viewCount',
        },
        {
          title: '播放时长',
          align: 'center',
          dataIndex: 'playBackDuration',
        },
        //  0-PC  1-app
        {
          title: '来源',
          align: 'center',
          dataIndex: 'source',
          scopedSlots: { customRender: 'source' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/aigoes/article/backstageList',
        delete: '/aigoes/article/delete',
        deleteBatch: '/aigoes/article/deleteBatch',
        exportXlsUrl: 'aigoes/article/exportXls',
        importExcelUrl: '/aigoes/article/importExcel',
      },
      typeMenu: {
        1: '心理健康',
        2: '家庭教育',
        3: '专家讲座',
        4: '亲子关系',
        5: '情绪管理',
        6: '育儿经验',
        7: '安全教育',
        8: '沟通技巧',
      },
      publishSettingOptions:{
        1: '普通发布',
        2: '家长学校',
        3: '轻干预方案',
      },
      worksNarrateMenu: {
        1: '取材网络',
        2: '引用站内',
        3: '个人观点，仅供参考',
        4: '引用AI',
        5: '虚构演绎，故事经历',
      },
      chargeStatusMenu: {
        0: '不收费文章',
        1: '收费文章',
      },
      contentTypeMenu: {
        1: '文章',
        2: '视频',
        3: '主题文章',
      },
      statusMenu: {
        0: '审核中',
        1: '已发布',
        2: '未通过',
        3: '草稿',
      },
      creationTypeMenu: {
        1: '原创',
        2: '转载',
      },
      sourceMenu: {
        0: 'PC',
        1: 'app',
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    goDetails(text) {
      console.log(text);
      
      const url = text.split(',')[0]
      console.log(url);
      
      window.open(window._CONFIG['resourceURL'] + '/school/sys/common/downloadSlice?filename='+url)
    },
    checkDetail(record) {
      console.log(record)
      this.selectRecord = record
      this.showPreview = true
    },
    handleOk() {
      this.showPreview = false
    },
    cancel() {
      this.showPreview = false
    },
    handleCancel() {
      this.visible = false
    },
    passConfirm(record) {
      httpAction(
        '/aigoes/article/articleReview',
        {
          userId: record.userId,
          id: record.id,
          status: 1,
        },
        'post'
      )
        .then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
          this.close()
        })
    },
    noPass(record) {
      this.visible = true
      this.selectRecord = record
    },
    noPassConfirm() {
      if (this.reason.length == '0') {
        return this.$message.warning('请输入不通过原因')
      } else {
        httpAction(
          '/aigoes/article/articleReview',
          {
            userId: this.selectRecord.userId,
            id: this.selectRecord.id,
            status: 2,
            reason: this.reason,
          },
          'post'
        )
          .then((res) => {
            if (res.success) {
              this.$message.success(res.message)
              this.$emit('ok')
            } else {
              this.$message.warning(res.message)
            }
          })
          .finally(() => {
            this.confirmLoading = false
            this.close()
          })
      }
      this.visible = false
    },
  },
  //   watch(
  //     showPreview,
  //     (newVal) => {
  //         console.log({ newVal })

  //         if (newVal) {
  //             document.body.style.overflow = 'hidden'
  //         } else {
  //             document.body.style.overflow = 'auto'
  //         }
  //     },
  //     {
  //         deep: true,
  //         immediate: false
  //     }
  // )
  watch: {},
}
</script>
<style scoped>
@import '~@assets/less/common.less';
* {
  box-sizing: border-box;
}
.preview {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 1000;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  height: 100vh;
}
.box {
  border-radius: 10px;
  width: 315px;
  height: 650px;
  background: url('./images/phone.png');
  background-size: 100% 100%;
  margin: 0 auto;
}
.myPhone {
  width: calc(100% - 10px);
  height: calc(100% - 120px);
  margin: 55px 5px 55px;
  padding: 10px;
  overflow: hidden;
  overflow-y: scroll;
}

.box::before,
.box::after {
  content: '';
  display: table;
}
.box::after {
  clear: both;
}
.myPhone::-webkit-scrollbar {
  display: none;
}
</style>
